import store from './store/index';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import MainRoutes from './MainRoutes';

import 'erxes-icon/css/erxes.min.css';
import 'react-datetime/css/react-datetime.css';
import 'react-toggle/style.css';
// global style

// import 'modules/theme/theme2/common/styles/global-styles.js';

import 'modules/theme/theme1/common/styles/global-styles.js'

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <MainRoutes />
    {/* <div>Hello There...</div> */}
  </Provider>,
  target
);



// WEBPACK FOOTER //
// ./src/index.js